import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';
import Spinner from '@tds/core-spinner';
import Input from '@tds/core-input';

import { EditOverlay } from '../../css';
import request from '../../../../../../../../utils/request';

const Overlay = ({ setInEditMode, id, name, fetchData }) => {
  const [dealershipName, setDealershipName] = useState(name);
  const [validationError, setValidationError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const prevNameRef = useRef();

  const resetState = () => {
    setIsUpdating(false);
    setInEditMode(false);
    setValidationError(false);
    fetchData();
  };

  const updateName = async () => {
    if (!name || name === dealershipName) {
      setValidationError(true);
      return;
    }
    setIsUpdating(true);
    try {
      const result = await request.post(`/dealerships/${id}`, {
        name: dealershipName
      });
      if (result && result.status === 200) {
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  useEffect(() => {
    if (prevNameRef.current && prevNameRef.current !== dealershipName)
      setInEditMode(false);

    prevNameRef.current = dealershipName;
  }, [name]);

  return (
    <EditOverlay>
      <Spinner label="updating..." spinning={isUpdating}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%'
          }}
        >
          <Input
            label="Dealership Name"
            defaultValue={dealershipName}
            value={dealershipName}
            onChange={e => setDealershipName(e.target.value)}
            feedback={validationError && 'error'}
            error={validationError && 'Name cannot be empty of same as before'}
          />
          <Button type="button" onClick={updateName}>
            Update
          </Button>
          <Button
            variant="secondary"
            type="button"
            onClick={() => setInEditMode(false)}
          >
            Cancel
          </Button>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  setInEditMode: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Overlay;
